import { render, staticRenderFns } from "./SideCenterAddEditor.vue?vue&type=template&id=b8aa138c&scoped=true&"
import script from "./SideCenterAddEditor.vue?vue&type=script&lang=js&"
export * from "./SideCenterAddEditor.vue?vue&type=script&lang=js&"
import style0 from "./SideCenterAddEditor.vue?vue&type=style&index=0&id=b8aa138c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8aa138c",
  null
  
)

export default component.exports